import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Routes from './routes';
import GlobalStyle from './styles-components/global';

const App = () => {

  return (
    <BrowserRouter>
      <GlobalStyle />
      <Routes />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        theme="colored"
        draggable
      />
    </BrowserRouter>
  )
}

export default App;
